import React from 'react';

import { createTheme } from '@mui/material/styles';

import {
  DEFAULT_THEME,
  THEME_STORAGE_KEY,
} from '../UnderMaintenance.constants';

import type { ThemeMode } from '@app/types';

export const useThemeMode = () => {
  const [themeMode, setThemeMode] = React.useState<ThemeMode>('light');

  React.useEffect(() => {
    const savedThemeState = localStorage.getItem(
      THEME_STORAGE_KEY,
    ) as ThemeMode | null;
    setThemeMode(savedThemeState ?? DEFAULT_THEME);
  }, []);

  return React.useMemo(() => {
    return createTheme({
      palette: {
        mode: themeMode,
      },
    });
  }, [themeMode]);
};
